var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15.901v3.094l5.062-2.991.53-.009a40.888 40.888 0 0 0 5.412-.462c.894-.135 1.515-.76 1.65-1.542C19.84 12.905 20 11.529 20 10s-.16-2.905-.346-3.99c-.135-.784-.756-1.407-1.65-1.543A40.515 40.515 0 0 0 12 4c-2.338 0-4.456.231-6.004.467-.894.136-1.515.76-1.65 1.542A23.701 23.701 0 0 0 4 10c0 1.529.16 2.905.346 3.99.118.68.593 1.226 1.285 1.456L7 15.901ZM2.375 5.67c.29-1.685 1.63-2.924 3.32-3.18C7.315 2.242 9.535 2 12 2c2.464 0 4.686.243 6.305.49 1.69.256 3.03 1.495 3.32 3.18C21.827 6.844 22 8.335 22 10s-.173 3.156-.375 4.33c-.29 1.685-1.63 2.923-3.32 3.18a42.899 42.899 0 0 1-5.68.485l-6.116 3.613A1 1 0 0 1 5 20.748v-3.404c-1.353-.45-2.375-1.567-2.625-3.014A25.7 25.7 0 0 1 2 10a25.7 25.7 0 0 1 .375-4.33Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H7Zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H7Z",
    fill: "#777E91"
  })));
};
export default SvgLine;